import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// helpers
import get from 'lodash.get';

// styles
import styles from './SbSharedTitle.scss';

// constants
import { pageTypeConstants as pageTypes } from '../../constants/pageTypeConstants';
const { SEARCH } = pageTypes;

const SbSharedTitleComponent = ({ itemSearch, searchTerm, customSearchHeader }) => {
    const header = get(itemSearch, 'meta.header');
    const pageType = get(itemSearch, 'pageType');

    const shownSearchTerm = get(itemSearch, 'spellCheck.newQuery') || searchTerm;

    return (
        <div className={styles.container}>
            <h1 className={styles.header} data-tn="header-title">
                {pageType === SEARCH ? (
                    <span>
                        {customSearchHeader || header}{' '}
                        <i className={styles.searchTerm} data-tn="search-term">
                            "{shownSearchTerm}"
                        </i>
                    </span>
                ) : (
                    header
                )}
            </h1>
        </div>
    );
};

SbSharedTitleComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    searchTerm: PropTypes.string,
    customSearchHeader: PropTypes.node,
};

export const SbSharedTitle = createFragmentContainer(SbSharedTitleComponent, {
    itemSearch: graphql`
        fragment SbSharedTitle_itemSearch on ItemSearchQueryConnection {
            pageType
            spellCheck {
                newQuery
            }
            meta {
                header
            }
        }
    `,
});
